import Api from '../Api';

import { url } from './config';
import { FrequentFlyer } from './types';

class ExtendedApi extends Api<FrequentFlyer> {}

const api = new ExtendedApi(url);

export default api;
